import { writable, get } from 'svelte/store';

const STORAGE_KEY = 'debugger-debug-mode';

function getInitial(): boolean {
  if (typeof window !== 'undefined') {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  }
  return false;
}

export const debugMode = writable<boolean>(getInitial());

export function toggleDebug() {
  debugMode.update(v => {
    const next = !v;
    localStorage.setItem(STORAGE_KEY, String(next));
    return next;
  });
}

export function debugLog(category: string, ...args: any[]) {
  if (get(debugMode)) {
    console.log(`%c[${category}]`, 'color: #EC7211; font-weight: bold', ...args);
  }
}

export function debugError(category: string, ...args: any[]) {
  if (get(debugMode)) {
    console.error(`%c[${category}]`, 'color: #F87171; font-weight: bold', ...args);
  }
}

export function debugTable(category: string, data: any) {
  if (get(debugMode)) {
    console.log(`%c[${category}]`, 'color: #EC7211; font-weight: bold');
    console.table(data);
  }
}
